import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { IPlayerProfileDataResponse } from '@modules/players/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { PLAYERS_PERMISSIONS } from '@modules/players/constants';
import { PLAYER_PROFILE_API_URL, PLAYER_PROFILE_QUERY_KEY } from '@modules/players/submodules/PlayerProfile/constants';

export default function usePlayerProfileQuery(playerId: Ref<string>, merchant: Ref<number>):
IContextQueryResult<IPlayerProfileDataResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery({
    queryKey: [PLAYER_PROFILE_QUERY_KEY, playerId, merchant],
    queryFn: () => fetchGet<IPlayerProfileDataResponse>(
      PLAYER_PROFILE_API_URL,
      {
        permission: PLAYERS_PERMISSIONS.PLAYERS_SHOW,
        urlParams: {
          playerId: playerId.value,
        },
        queryParams: {
          merchant: merchant.value,
        },
      },
    ),
    enabled: computed(() => !!(playerId.value && merchant.value)),
  });
}
